import React, {useState} from 'react';
import { useDispatch } from 'react-redux';
import TableCell from '@mui/material/TableCell'; //actualziacion nodejs
import TableRow from '@mui/material/TableRow'; //actualziacion nodejs
import Modal from '@mui/material/Modal'; //actualziacion nodejs
import Fade from '@mui/material/Fade'; //actualziacion nodejs
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button'; //actualización nodejs
import Divider from '@mui/material/Divider'; //actualizacion nodejs
import Card from '@mui/material/Card'; //actualizacion nodejs
import CardContent from '@mui/material/CardContent'; //actualizacion nodejs
import './index.css'

//COMPONENTES STYLED
const CustomModal = styled(Modal)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}); 

const StyledCard = styled(Card)({
  minWidth: 275,
});

const Title = styled('h2')({
  fontSize: 25,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

const Subtitle = styled('p')({
  fontSize: '18px',
  margin: '4px 0',
});

const StyledPaper = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  padding: '20px 32px',
  margin: '10px 40px',
  borderRadius: '10px',
  outline: 'none',
}));

const ButtonGroup = styled('div')({
  justifyContent: 'space-around',
  alignItems: 'center',
  display: 'flex',
  marginTop: 20,
});

const StyledTableRow = styled(TableRow)({
  cursor: 'pointer',
  tabIndex: "-1"
});


export default function Cliente(props) {
  const [modalVisible, setModalVisible] = useState(false);
  let { data: { NAME1, KUNNR, facturas, STCD1, SMTP_ADDR, 
    TEL_NUMBER, CITY1, POST_CODE1, CITY2, STREET,
    REGION, HOUSE_NUM1, TTX_NUMBER, VKBUR, KUNN2,}, index} = props;
    let { data } = props;
    const dispatch  = useDispatch();
  let alertOnchange = () =>{
    setModalVisible(!modalVisible);
  }

  const getFacturasPendientes = (faturas) =>{
    let faturafinal = "";
    let masDeUna = faturas && faturas.length? true: false;
    if( masDeUna ){
      faturafinal = `Facturas pendientes: ${faturas.length}`;
    }else if(faturas.length === 1){
      faturafinal =`Factura pendiente: 1`;
    }else{
      faturafinal =`Sin facturas pendientes`;
    }
    return faturafinal;
  }

  let facturasPendientes= getFacturasPendientes(facturas);

  function clienteCobrar(){
    dispatch({type:"CLIENTE_COBRAR", payload: { clienteCobrar:data } })
  }

  return (
    <>
      <CustomModal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open = {modalVisible}
        onClose = {alertOnchange}
        closeAfterTransition
        slotProps= {{
          backdrop: {timeout: 500}
        }}
      >
        <Fade in={modalVisible}>
          <StyledPaper>
            <Title id="transition-modal-title" >Datos del cliente</Title>
            <Subtitle id="transition-modal-title">{`Nombre: ${NAME1}`}</Subtitle>
            
            <Subtitle>{`Clave: ${KUNNR}`}</Subtitle>
            <Subtitle>{`RFC: ${STCD1}`}</Subtitle>
            <Subtitle>{`${SMTP_ADDR? "Email: " + SMTP_ADDR: ""}`}</Subtitle>
            <Subtitle>{`${TEL_NUMBER? "Telefono:" +TEL_NUMBER:"" }`}</Subtitle>
            <Subtitle>{`Referencia de Pago: ${TTX_NUMBER? TTX_NUMBER: "No registrada"}`}</Subtitle>
            <Divider/>
            <Subtitle style={{alignContent:"center"}}>{`Direccion`}</Subtitle>
            <Subtitle>{`\tCalle: ${STREET? STREET : "'Sin información'"}`}</Subtitle>      
            <Subtitle>{`\tNumero: ${HOUSE_NUM1? HOUSE_NUM1 : "'Sin información'"}`}</Subtitle>  
            <Subtitle>{`\tColonia: ${CITY2? CITY2 : "'Sin información'"}`}</Subtitle>  
            <Subtitle>{`\tCP: ${POST_CODE1? POST_CODE1 : "'Sin información'"}`}</Subtitle>  
            <Subtitle>{`\tCiudad: ${CITY1? CITY1: "'Sin información'"}`}</Subtitle>  
            <Subtitle>{`\tEstado: ${REGION?REGION: "'Sin información'"}`}</Subtitle>  
            <ButtonGroup>
              <Button  variant="contained" color="primary" onClick={() => { clienteCobrar(); }}> Cobrar </Button>
              <Button  variant="contained" color="primary" onClick={() => { setModalVisible(!modalVisible); }}> Ok </Button>
            </ButtonGroup>
          </StyledPaper>
        </Fade>
      </CustomModal> 
      <StyledTableRow hover role="checkbox" tabIndex={-1} key={index + NAME1} onClick={() => { setModalVisible(true); }}>
        <TableCell key={KUNNR} align={"center"}>
          <StyledCard>
            <CardContent>
              <Subtitle>
                {`${NAME1}`} 
                <br />
                {`No. cliente: ${KUNNR}`} 
                <br />
                {`Sucursal: ${VKBUR}`} 
                <br />
                {`Vendedor: ${KUNN2}`} 
                <br />
                {`${facturasPendientes}`} 
              </Subtitle>
            </CardContent>
          </StyledCard>
        </TableCell>
      </StyledTableRow>
    </>
  );
};
